import styled from "styled-components";
import Variables from "../../assets/styleVariables";

const COLORS = {
  primary: {
    background: Variables.colors.primary_100,
    color: Variables.colors.primary
  },
  success: {
    background: Variables.colors.green_100,
    color: Variables.colors.green_800
  },
  warning: {
    background: Variables.colors.yellow_100,
    color: Variables.colors.red
  },
  secondary: {
    background: Variables.colors.complementary_300,
    color: Variables.colors.complementary_700
  },
  outline: {
    background: Variables.colors.complementary,
    color: Variables.colors.complementary_900
  },
  normal: {
    background: Variables.colors.complementary_250,
    color: Variables.colors.complementary_700
  }
};

export const Box = styled.div`
  position: relative;
  width: 100%;
  height: inherit;
  .notice {
    margin-bottom: 8px;
    display: block;
    padding: 4px 0;
    font-size: ${Variables.font_sizes.x_small};
    color: ${Variables.colors.red_600};
  }
`;
export const BoxOpenView = styled.div`
  .options {
    margin-top: 5px;
    list-style: none;
    background-color: ${Variables.colors.complementary};
    border-radius: 4px;
    box-shadow: 0 2px 14px 0 #cccccc;
    padding: 4px 0;
    position: absolute;
    width: 100%;
    display: ${props => (props.status ? "block" : "none")};
    z-index: 900;
    height: auto;
    max-height: 183px;
    overflow-y: auto;
    li {
      padding: 8px 8px;
      margin: 0;
      cursor: pointer;
      font-size: ${Variables.font_sizes.medium};
      &:hover {
        background-color: ${Variables.colors.complementary_200};
      }
    }
  }
`;
export const BoxCloseView = styled.div`
    height: inherit;
    border-radius: 4px;
    border: ${props =>
      props.hasBorder ? "1px solid " + Variables.colors.complementary_450 : 0};
    background-color: ${props =>
      props.status
        ? Variables.colors.complementary_450
        : props.type
        ? COLORS[`${props.type}`].background
        : Variables.colors.complementary_250};
    
    padding: ${props =>
      props.size === "small" ? "2px 9px 2px 25px" : "12px 12px 12px 40px"} ;
    
    cursor: pointer;
    font-size: ${Variables.font_sizes.x_medium};
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &>div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      height: 100%;
      display: flex;
      opacity: ${props => (props.className.includes("disabled") ? "0.3" : "1")};
      .selected{
        display: flex;
        color: ${props =>
          props.type
            ? COLORS[`${props.type}`].color
            : Variables.colors.complementary_900};
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        &.default{
          color: ${Variables.colors.complementary_700};
        }
        .select-box-item-icon{
          padding-left:  ${props => (props.hasIcon ? "10px" : "0")};
            i{
              display: flex;
              &:before{
                margin: 0;
              }
              &.small{
                &:before{
                  font-size: ${Variables.font_sizes.little};
                }
              }
              &.big{
                &:before{
                  font-size: ${Variables.font_sizes.small};
                }
              }
          }
        }
      }
    }
    &>i {
      opacity: ${props => (props.className.includes("disabled") ? "0.3" : "1")};
      width: ${props => (props.size === "small" ? "15px" : "40px")};
      height:  ${props => (props.size === "small" ? "15px" : "40px")};
      padding-left: ${props => (props.size === "small" ? "9px" : "0")};
      padding-top: 1px;
      position: absolute;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      &:before {
        font-size: ${props =>
          props.size === "small" ? "6px" : Variables.font_sizes.small};
        display: block;
        margin-left: 0;
      }
    }
`;
